/* Aus snippets/sk-wish-ship-day-assets.liquid ausgelagert (PERF 31.10.2026, Philipp 31.10.: Skript-Projekt) – unverändert, lädt defer und wird gecacht. */
(function () {
  if (window.skWishShip) return;
  var BERLIN = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  });
  var SPAN_DAYS = 21;
  var SAME_DAY_CUTOFF_MIN = 7 * 60 + 30;

  function berlinNow() {
    var p = {};
    BERLIN.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { key: p.year + '-' + p.month + '-' + p.day, min: Number(p.hour) * 60 + Number(p.minute) };
  }
  function toUtc(key) {
    var a = key.split('-');
    return new Date(Date.UTC(Number(a[0]), Number(a[1]) - 1, Number(a[2]), 12));
  }
  function addDays(key, n) {
    var d = toUtc(key);
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return y + '-' + String(month).padStart(2, '0') + '-' + String(day).padStart(2, '0');
  }
  var holidayCache = {};
  function holidays(y) {
    if (holidayCache[y]) return holidayCache[y];
    var e = easter(y);
    var list = [y + '-01-01', addDays(e, -2), addDays(e, 1), y + '-05-01', addDays(e, 39), addDays(e, 50), y + '-10-03', y + '-12-25', y + '-12-26'];
    holidayCache[y] = list;
    return list;
  }
  function selectable(key) {
    var wd = toUtc(key).getUTCDay();
    if (wd < 1 || wd > 5) return false;
    return holidays(Number(key.slice(0, 4))).indexOf(key) === -1;
  }
  function days() {
    var now = berlinNow();
    var start = now.min < SAME_DAY_CUTOFF_MIN ? now.key : addDays(now.key, 1);
    var out = [];
    for (var i = 0; i <= SPAN_DAYS; i++) {
      var k = addDays(start, i);
      if (selectable(k)) out.push(k);
    }
    return out;
  }
  function label(key, lang) {
    try {
      return new Intl.DateTimeFormat(lang || 'de', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' }).format(toUtc(key));
    } catch (_) {
      return key;
    }
  }
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function save(box, value) {
    var attrs = {};
    attrs[box.getAttribute('data-key')] = value;
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      box.setAttribute('data-current', value);
      return r.json();
    });
  }
  function setStatus(box, text, isError) {
    var st = box.querySelector('[data-sk-wish-ship-status]');
    if (!st) return;
    st.textContent = text || '';
    st.classList.toggle('sk-wish-ship__status--error', !!isError);
  }
  function mount(box) {
    if (!box || box.getAttribute('data-sk-wish-ship-mounted') === '1') return;
    box.setAttribute('data-sk-wish-ship-mounted', '1');
    var current = box.getAttribute('data-current') || '';
    if (box.getAttribute('data-clear') === '1') {
      save(box, '').catch(function () {});
      return;
    }
    var sel = box.querySelector('[data-sk-wish-ship-select]');
    if (!sel) return;
    var lang = box.getAttribute('data-lang') || 'de';
    var list = days();
    list.forEach(function (k) {
      var o = document.createElement('option');
      o.value = k;
      o.textContent = label(k, lang);
      sel.appendChild(o);
    });
    if (current && list.indexOf(current) !== -1) {
      sel.value = current;
    } else if (current) {
      // Gewählter Tag ist vorbei/ungültig → nächstmöglich.
      save(box, '').catch(function () {});
    }
    sel.addEventListener('change', function () {
      var v = sel.value;
      sel.disabled = true;
      setStatus(box, box.getAttribute('data-saving'));
      save(box, v).then(function () {
        setStatus(box, box.getAttribute('data-saved'));
      }).catch(function () {
        sel.value = box.getAttribute('data-current') || '';
        setStatus(box, box.getAttribute('data-error'), true);
      }).then(function () {
        sel.disabled = false;
      });
    });
  }
  function mountAll() {
    var boxes = document.querySelectorAll('[data-sk-wish-ship]');
    for (var i = 0; i < boxes.length; i++) mount(boxes[i]);
  }
  var refreshTimer = null;
  function refreshDrawerSlot() {
    var slot = document.querySelector('[data-sk-wish-ship-slot]');
    if (!slot) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch(root() + '?sections=sk-wish-ship-day', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || typeof j['sk-wish-ship-day'] !== 'string') return;
          var tmp = document.createElement('div');
          tmp.innerHTML = j['sk-wish-ship-day'];
          var box = tmp.querySelector('[data-sk-wish-ship]');
          if (!box) return;
          box.className = box.className.replace('sk-wish-ship--cart', 'sk-wish-ship--drawer');
          var sel = box.querySelector('select');
          if (sel) sel.id = 'sk-wish-ship-drawer';
          var lab = box.querySelector('label');
          if (lab) lab.setAttribute('for', 'sk-wish-ship-drawer');
          slot.innerHTML = '';
          slot.appendChild(box);
          mount(box);
        })
        .catch(function () {});
    }, 350);
  }
  function watchDrawer() {
    var drawer = document.querySelector('[data-sk-drawer]');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (drawer.getAttribute('aria-hidden') === 'false') refreshDrawerSlot();
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }
  window.addEventListener('sk:cart-changed', refreshDrawerSlot);
  window.skWishShip = { refresh: refreshDrawerSlot, mountAll: mountAll, days: days };
  function boot() { mountAll(); watchDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
